import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionsService } from '@app/services/permissions/permissions.service';



export const allFailedMailsGuard: CanActivateFn = () => {
  const permissionService = inject(PermissionsService);
  const router = inject(Router);

  const userId = permissionService.userid;

  if (userId === 30127 || userId === 2058730) {
    return true;
  }

  return router.createUrlTree(['/']);
};
